module.exports = __webpack_public_path__ + "static/img/beijing (2).7a1e71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/beijing (2).png
// module id = P2xM
// module chunks = 1